import { render } from "./CBTable.vue?vue&type=template&id=fa31331e"
import script from "./CBTable.vue?vue&type=script&lang=js"
export * from "./CBTable.vue?vue&type=script&lang=js"

import exportComponent from "/builds/shapkin/crm-mentoring.exportedu.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__